<label class="relative inline-flex items-center cursor-pointer">
	<input type="checkbox" class="sr-only peer" (click)="toggle()" (keydown.enter)="toggle()">
	<div
		class="w-10 h-6 bg-peps-dark-700 peer rounded-sm peer-checked:bg-peps-gold transition-colors duration-300 border border-peps-dark-400"
	></div>
	<div
		class="absolute left-0.5 top-0.5 w-5 h-5 rounded-xs bg-peps-dark-400 peer-checked:bg-peps-dark-700 transition-transform duration-300 peer-checked:translate-x-4"
	></div>
</label>

